var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonSocialOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SalonSocial",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.399,
    height: 59.504,
    viewBox: "0 0 53.399 59.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006533;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    className: "cls-1",
    width: 53.399,
    height: 59.504
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-1",
    d: "M218.715,0a1.41,1.41,0,0,1,.995,1.525c-.023,1.121.018,2.244-.015,3.365s-1.232,1.733-1.984.8a1.484,1.484,0,0,1-.311-.854c-.065-1.192-.017-2.39-.025-3.585a1.359,1.359,0,0,1,.735-1.17l.6-.081",
    transform: "translate(-192.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-1",
    d: "M253.719,85.54c1.671-.324,3.32-.642,4.967-.965a3.063,3.063,0,0,1,1.3,5.987q-6.339,1.282-12.693,2.486a3.067,3.067,0,0,1-1.224-5.991c1.527-.345,3.07-.617,4.606-.922.223-.044.445-.1.7-.15l-2.55-13.061c-3.66-.337-5.919-2.633-7.776-5.437a26.494,26.494,0,0,1-3.855-10.78,59.149,59.149,0,0,1-.469-14.3c.172-1.963.23-2.032,2.174-2.4q4.87-.933,9.735-1.9c1.023-.2,1.36-.06,1.84.84A54.31,54.31,0,0,1,256.4,56.259a20.91,20.91,0,0,1-1.15,11.631,8.331,8.331,0,0,1-3.843,4.416.526.526,0,0,0-.235.429q1.216,6.322,2.469,12.636a1.065,1.065,0,0,0,.08.169M254.027,56a55.458,55.458,0,0,0-5.381-15.521l-9.563,1.869A56.264,56.264,0,0,0,239.439,56Zm.269,2.4H239.878a23.357,23.357,0,0,0,2.927,7.5,11.333,11.333,0,0,0,3.55,3.844,4.285,4.285,0,0,0,3.076.752,4.664,4.664,0,0,0,3.3-2.762A17.568,17.568,0,0,0,254.3,58.4m5.763,29.281c0-.637-.341-.936-.957-.816q-6.116,1.195-12.232,2.391c-.495.1-.789.286-.667.852.127.592.308.718.94.6q3.159-.609,6.318-1.221,2.93-.57,5.86-1.146c.378-.074.733-.165.738-.655",
    transform: "translate(-208.966 -33.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-1",
    d: "M8.719,85.572l2.4-12.944A22.278,22.278,0,0,1,8.844,70.78a12.275,12.275,0,0,1-2.923-6.521,26.7,26.7,0,0,1,.466-10.878,57.87,57.87,0,0,1,5.353-14.35c.52-.975.823-1.108,1.919-.894q5.208,1.016,10.417,2.022c.983.19,1.259.516,1.366,1.5a54.636,54.636,0,0,1,.205,9.739,38,38,0,0,1-2.549,12.5,17.426,17.426,0,0,1-5.381,7.43A7.753,7.753,0,0,1,13.841,72.9a.628.628,0,0,0-.453.362c-.8,4.2-1.571,8.4-2.346,12.6a.662.662,0,0,0,.033.168c1.586.31,3.192.633,4.8.936a2.967,2.967,0,0,1,2.482,4.112,2.835,2.835,0,0,1-3.195,2Q8.727,91.85,2.3,90.561A2.812,2.812,0,0,1,0,87.748,3,3,0,0,1,2.36,84.586a5.518,5.518,0,0,1,1.834.105c1.484.258,2.958.572,4.526.881m4.86-45.078C10.6,46.516,8.331,52.7,7.871,59.509h.7c4.3,0,8.595-.011,12.892.014.535,0,.723-.162.832-.667a51.951,51.951,0,0,0,1.126-11.005c0-1.815-.123-3.629-.191-5.47L13.58,40.494M7.971,61.867a12.873,12.873,0,0,0,2.283,7,4.034,4.034,0,0,0,2.467,1.62,4.641,4.641,0,0,0,3.846-1.231,14.6,14.6,0,0,0,4-5.411c.3-.63.55-1.286.845-1.982Zm8.258,27.991c-.007-.365-.284-.5-.667-.579q-6.146-1.194-12.289-2.4c-.576-.112-.781.036-.895.608-.106.532.049.741.656.86q6.117,1.192,12.234,2.38c.627.122.945-.143.961-.867",
    transform: "translate(0 -33.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-1",
    d: "M176.747,6.432a1.894,1.894,0,0,1-.757.785.878.878,0,0,1-1.207-.234,28.873,28.873,0,0,1-1.727-2.874,1.033,1.033,0,0,1,.489-1.3A1.048,1.048,0,0,1,174.922,3c.627.924,1.174,1.9,1.745,2.863a.69.69,0,0,1,.08.572",
    transform: "translate(-152.837 -2.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-1",
    d: "M255.083,3.943a10.146,10.146,0,0,1-2.035,3.17.927.927,0,0,1-1.235-.089.971.971,0,0,1-.387-1.229,32.424,32.424,0,0,1,1.741-2.866A.967.967,0,0,1,254.39,2.7a1.175,1.175,0,0,1,.693,1.247",
    transform: "translate(-222.073 -2.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-1",
    d: "M337.128,117.014a1.193,1.193,0,0,1-.891,1.269,1.057,1.057,0,0,1-1.286-.638q-.792-2.33-1.5-4.689a1.107,1.107,0,0,1,.761-1.277,1.157,1.157,0,0,1,1.485.767c.444,1.3.846,2.607,1.26,3.913.081.256.134.521.168.655",
    transform: "translate(-294.613 -98.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-1",
    d: "M319.546,77.04a1.185,1.185,0,0,1-1.177-1.125,1.159,1.159,0,1,1,2.319-.035,1.182,1.182,0,0,1-1.142,1.16",
    transform: "translate(-281.314 -66.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-1",
    d: "M169.3,96.61c-.085,1.311-.158,2.622-.258,3.932a1.146,1.146,0,0,1-1.237,1.172,1.162,1.162,0,0,1-1.079-1.273q.075-3.5.185-7.007a1.159,1.159,0,1,1,2.313-.014c.041,1.061.01,2.125.01,3.187l.066,0",
    transform: "translate(-147.319 -81.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-1",
    d: "M162.255,193.867a1.16,1.16,0,1,1-1.044,1.651,1.161,1.161,0,0,1,1.044-1.651",
    transform: "translate(-142.348 -171.302)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSocialOrange);
export default __webpack_public_path__ + "static/media/SalonSocial_orange.c8371fef6981cd53170f7484c5c50078.svg";
export { ForwardRef as ReactComponent };